import { Injectable } from '@angular/core';
//import { Http, IRequestOptionsArgs, Response } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
//import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/timeout';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/throw';

@Injectable()
export abstract class HttpBase {
    protected constructor(private readonly http: HttpClient, private readonly router: Router, private readonly translateService: TranslateService) {
        // this.host = 'http://localhost:8082';
        this.host = '';
    }

    private readonly host: string;

    private makeHttpCall = <T>(call: () => Observable<T>): Observable<T> => {
        return call().catch((e: HttpErrorResponse) => {
            switch (e.status) {
            case 401:
                $('body').removeClass('modal-open').children('.modal-backdrop').remove();
                this.router.navigate(['login'],
                    { queryParams: { returnUrl: window.location.pathname + window.location.search } });
                return Observable.throw(401);
            case 0:
                if (e.url == null)
                    return new Observable(subscriber => {
                        this.translateService.get('ConnectServerError').subscribe(e => {
                            subscriber.error(e);
                            subscriber.complete();
                        });
                    });
                break;
            }

            return Observable.throw((e.error && e.error.error) || e.error || e);
        });
    };

    private extendsOptions = (options: IRequestOptionsArgs): IRequestOptionsArgs => {
        if (!options)
            options = {};

        options.withCredentials = true;

      if (options.params) {
        if (options.params instanceof HttpParams) {
          const httpParams = options.params as HttpParams;
          for (const param of httpParams.keys())
              if (httpParams.get(param) == null)
                  httpParams.delete(param);
        }
        else
          for (let param in options.params)
              if (options.params.hasOwnProperty(param) && options.params[param] == null)
                  delete options.params[param];
      }

        return options;
    };

    protected get = <T>(url: string, options?: IRequestOptionsArgs): Observable<T> => {
        return this.makeHttpCall<T>(() => this.http.get<T>(this.host + url, this.extendsOptions(options)));
    };

    protected post = <T>(url: string, body: any, options?: IRequestOptionsArgs): Observable<T> => {
        return this.makeHttpCall<T>(() => this.http.post<T>(this.host + url, body, this.extendsOptions(options)));
    };

    protected delete = <T>(url: string, options?: IRequestOptionsArgs): Observable<T> => {
        return this.makeHttpCall<T>(() => this.http.delete<T>(this.host + url, this.extendsOptions(options)));
    };
    //private makeHttpCall = <T>(call: () => Observable<Response>): Promise<T> => {
    //    return new Promise<T>((resolve, reject) => {
    //        call().toPromise().then(r => {
    //            resolve((r as Response).json() as T);
    //        }).catch(e => {
    //            if (e.status === 401) {
    //                this.router.navigate(['login'],
    //                    { queryParams: { returnUrl: window.location.pathname + window.location.search } });
    //                return;
    //                //throw new Error('Authentication required');
    //            }

    //            reject(e);
    //        });
    //    });
    //}

    //private extendsOptions = (options: IRequestOptionsArgs): IRequestOptionsArgs => {
    //    if (!options)
    //        options = {};

    //    options.withCredentials = true;

    //    return options;
    //}

    //protected get = <T>(url: string, options?: IRequestOptionsArgs): Promise<T> => {
    //    return this.makeHttpCall<T>(() => this.http.get(this.host + url, this.extendsOptions(options)));
    //}

    //protected post = <T>(url: string, body: any, options?: IRequestOptionsArgs): Promise<T> => {
    //    return this.makeHttpCall<T>(() => this.http.post(this.host + url, body, this.extendsOptions(options)));
    //}

    //protected delete = <T>(url: string, options?: IRequestOptionsArgs): Promise<T> => {
    //    return this.makeHttpCall<T>(() => this.http.delete(this.host + url, this.extendsOptions(options)));
    //}
}

export interface IRequestOptionsArgs {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    observe?: any;
    params?: HttpParams | {[param: string]: string | string[]} | {};
    reportProgress?: boolean;
    responseType?: any;
    withCredentials?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/services/http-base.service.ts